module["exports"] = [
  "Rua",
  "Avenida",
  "Travessa",
  "Alameda",
  "Marginal",
  "Rodovia"
];
